import Vue from 'vue';

const RwEventBus = new Vue();
export default RwEventBus;